import { useAuthStore } from '@/stores/authStore';
import { useImpersonationStore } from '@/stores/impersonationStore';

/**
 * Hook to get the effective user ID for data operations.
 * Returns the impersonated user ID if impersonation is active,
 * otherwise returns the real authenticated user ID.
 */
export const useEffectiveUserId = (): string | null => {
  const { userId } = useAuthStore();
  const { getEffectiveUserId } = useImpersonationStore();
  
  return getEffectiveUserId(userId);
};

/**
 * Hook to get impersonation state and the effective user for display.
 * Useful for components that need to show impersonation status.
 */
export const useImpersonation = () => {
  const { userId: realUserId } = useAuthStore();
  const { 
    isImpersonating, 
    impersonatedUser, 
    startImpersonation, 
    stopImpersonation,
    getEffectiveUserId 
  } = useImpersonationStore();
  
  return {
    isImpersonating,
    impersonatedUser,
    realUserId,
    effectiveUserId: getEffectiveUserId(realUserId),
    startImpersonation,
    stopImpersonation,
  };
};
